import IncomingCallPanelComponent from './IncomingCallPanel.component';

export * from './IncomingCallPanel.component';
export default IncomingCallPanelComponent;